import TimelineX from "./Components/Timeline/Timeline";

const History = () => {



  return (
    <div style={{marginBottom:500, width:"100%"}}>
      <TimelineX/>
    </div>
  )
}

export default History